import { whatsappCanSend, whatsappStatusLabel } from '@crm/shared';
import type { Unit } from '@/modules/company';
import type { PhoneLine } from '../api';

export type UnitSetup = 'nova' | 'preparando' | 'conectada';

export interface UnitSituation {
  setup: UnitSetup;
  label: string;
  tone: string;
}

export function situacaoDaUnidade(unit: Unit, linha: PhoneLine | null): UnitSituation {
  if (!linha && !unit.whatsappFrom) {
    return { setup: 'nova', label: 'Nao configurado', tone: 'none' };
  }

  if (linha?.openCharge)
    return { setup: 'preparando', label: 'Aguardando pagamento', tone: 'wait' };
  if (!unit.whatsappFrom)
    return { setup: 'preparando', label: 'Preparando o numero', tone: 'wait' };
  // Numero salvo e sem estado nenhum quer dizer que ele nao foi encontrado
  // como remetente - diferente de nao ter numero.
  if (!unit.whatsappStatus) {
    return { setup: 'preparando', label: 'Numero nao habilitado', tone: 'bad' };
  }

  const estado = whatsappStatusLabel(unit.whatsappStatus);

  return { setup: whatsappCanSend(unit.whatsappStatus) ? 'conectada' : 'preparando', ...estado };
}

export function linhaDaUnidade(linhas: PhoneLine[], unitId: string): PhoneLine | null {
  return linhas.find((linha) => linha.unitId === unitId) ?? null;
}

export interface UnitProgress {
  aguarda: string;
  problema?: boolean;
}

export function andamentoDaUnidade(unit: Unit, linha: PhoneLine | null): UnitProgress {
  if (!linha || linha.openCharge) {
    return { aguarda: 'O numero e comprado assim que a mensalidade for paga.' };
  }

  if (!unit.whatsappFrom) {
    return { aguarda: 'Compra do numero e registro do remetente em andamento.' };
  }

  if (!unit.whatsappStatus) {
    return {
      aguarda:
        'O numero nao esta registrado como remetente de WhatsApp no provedor e nenhuma mensagem e enviada por ele. Use Registrar de novo para habilitar o envio.',
      problema: true,
    };
  }

  return { aguarda: 'A Meta esta analisando o numero. A liberacao costuma levar algumas horas.' };
}
